import { render } from "./ContactForm.vue?vue&type=template&id=61293334&scoped=true&bindings={\"eventType\":\"data\",\"name\":\"data\",\"idea\":\"data\",\"phone\":\"data\",\"email\":\"data\",\"step\":\"data\",\"handleNameStep\":\"options\",\"handleIdeaStep\":\"options\",\"handlePhoneStep\":\"options\",\"handleEmailStep\":\"options\",\"close\":\"options\",\"submitForm\":\"options\"}"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=61293334&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61293334"

export default script